<template>
  <popup-base @close="close">
    <template #header>
      <h3 style="margin: 0">Extra wensen</h3>
    </template>
    <template #body>
      <div class="extra-wishes-wrapper">
        <div class="textarea-wrapper">
          <textarea
              class="form-control textarea"
              name="description"
              cols="30"
              rows="4"
              v-model="extraWishes"
              placeholder="Geef hier jouw extra wensen aan..."
          ></textarea>

          <button-primary
              class="btn-extra-wishes emat-btn emat-btn-primary"
              @click="save"
              :btn-block="true"
          >Extra wensen opslaan</button-primary>
        </div>
      </div>
    </template>
  </popup-base>
</template>

<script>
import PencilEdit from '../../../../assets/icons/pencil_edit.svg?inline'
import PopupBase from "../Base/PopupBase";
import ButtonPrimary from '../../../Buttons/Primary/ButtonPrimary'

export default {
  name: 'PopupExtraWishes',

  components: {
    PopupBase,
    PencilEdit,
    ButtonPrimary
  },

  props: {
    /**
     * Value of the extra wishes
     */
    value: {
      type: String,
      default: null,
      previousValue: null,
    }
  },

  data() {
    return {
      extraWishes: null,
    }
  },

  methods: {
    save() {
      /**
       * Get the value of the extra wishes
       */
      this.$emit('input', this.extraWishes);
      this.close();
    },

    close() {
      /**
       * Close the popup
       */
      this.$emit('close');
    },
  },

  created() {
    this.extraWishes = this.value;
  }
}
</script>

<style scoped lang="scss">
@import "../../../../assets/sass/abstracts";

.extra-wishes-wrapper {
  height: 100%;
  //border-radius: $border-radius;
}

.textarea-wrapper {
  @include header-font;
  padding: 12px $card-padding;
  background-color: var(--c-primary-lightest);
  font-size: 14px;
  color: #7d7d7d;
  border: none;
  border-radius: 0 0 $border-radius $border-radius;

  textarea {
    box-sizing: border-box;
    padding: 5px;
    resize: none;
    border: 1px solid #e5e5e5;
    outline: none;
    width: 100%;
    height: 150px;
    font-family: var(--font);
    font-weight: normal;
    color: #7d7d7d;
    font-size: 14px;
  }

  h3 {
    color: var(--c-primary);
    padding-bottom: 10px;
  }
}

.btn-extra-wishes {
  @include header-font;
  margin-top: 8px;
  height: 40px;
}
</style>
